export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Damit Ihre Kameratechnik dauerhaft zuverlässig arbeitet',
      lead: 'SSG Care ist unser Wartungs- und Betreuungsabonnement. Nach der Installation können Sie Ihre Anlage in einem flexiblen Care-Vertrag laufend betreuen lassen – gegen eine monatliche Gebühr und mit individuell vereinbarter Laufzeit.',
    },
    abo: {
      title: 'Abomodell mit flexibler Laufzeit',
      lead: 'Die Installation wird einmalig abgerechnet. Die laufende Betreuung läuft über ein monatliches Abonnement – kündbar oder mit fest vereinbarter Mindestlaufzeit.',
      items: {
        '0': { title: 'Monatliche Betreuung', desc: 'Wählen Sie zwischen monatlich kündbar oder einer festen Laufzeit (z. B. 12 oder 24 Monate) mit entsprechenden Konditionen.' },
        '1': { title: 'Individueller Leistungsumfang', desc: 'Nicht jede Anlage braucht alles. Wir definieren gemeinsam, welche Services in Ihren Care-Vertrag gehören – skalierbar und anpassbar.' },
        '2': { title: 'Keine versteckten Kosten', desc: 'Transparente monatliche Gebühr. Zusatzleistungen außerhalb des Vertrags werden vorab abgesprochen und gesondert berechnet.' },
      },
    },
    pricing: {
      eyebrow: 'Tarife',
      title: 'Wählen Sie Ihren Care-Tarif',
      lead: 'Alle Preise sind Richtwerte. Die finale monatliche Gebühr hängt von Ihrer Anlagengröße, dem gewünschten Leistungsumfang und der Laufzeit ab.',
      featured: 'Beliebteste Wahl',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Für kleine Anlagen', price: 'ab 19 €/Monat', features: { '0': 'Vierteljährliche Systemprüfung (Remote)', '1': 'Firmware-Update-Management', '2': 'App-Support per Telefon/E-Mail', '3': 'Priorisierte Supportanfragen' } },
        '1': { name: 'Care Professional', subtitle: 'Für gewerbliche Anlagen', price: 'ab 39 €/Monat', features: { '0': 'Monatliche Systemprüfung (Remote)', '1': 'Firmware-Updates & Sicherheitspatches', '2': 'Benutzer- und Rechteverwaltung', '3': 'Speicher- & Aufzeichnungskontrolle', '4': 'Hilfe bei Smartphone-Wechsel', '5': 'Vor-Ort-Service nach Vereinbarung', '6': 'Priorisierte Bearbeitung' } },
        '2': { name: 'Care Enterprise', subtitle: 'Für Multi-Site & Großprojekte', price: 'Individuell', features: { '0': 'Wöchentliche Systemprüfung (Remote)', '1': 'Alle Leistungen aus Professional', '2': 'Dedizierter Ansprechpartner', '3': 'Proaktive Erweiterungshinweise', '4': 'Regelmäßige Vor-Ort-Termine', '5': 'Dokumentation & Reporting' } },
      },
    },
    services: {
      title: 'Was SSG Care für Sie tun kann',
      items: {
        '0': { title: 'Regelmäßige Systemprüfung', desc: 'Kontrolle von Kamerafunktion, Aufzeichnung und Netzwerkverbindung – je nach Paket remote oder vor Ort.' },
        '1': { title: 'Firmware-Updates', desc: 'Prüfung und Durchführung vereinbarter Firmware-Updates nach Herstellervorgaben für Sicherheit und Stabilität.' },
        '2': { title: 'App- und Zugriffssupport', desc: 'Unterstützung bei App-Problemen, Zugriffsfragen und Hilfe beim Smartphone-Wechsel oder Neuinstallation.' },
        '3': { title: 'Benutzer- und Rechteverwaltung', desc: 'Verwaltung von Zugriffsrechten, neuen Benutzern und Berechtigungsänderungen für Mitarbeiter und Familie.' },
        '4': { title: 'Aufzeichnung und Speicher', desc: 'Prüfung von Speicherbelegung, Aufzeichnungsqualität und Backup-Status Ihres Rekorders.' },
        '5': { title: 'Remote-Unterstützung', desc: 'Fernzugriff zur Diagnose und Konfiguration, wenn technisch möglich und von Ihnen gewünscht.' },
      },
    },
    form: {
      title: 'Ihr persönliches Care-Angebot',
      lead: 'Teilen Sie uns mit, welche Betreuung Sie sich vorstellen. Wir melden uns mit einem individuellen Vorschlag inklusive Laufzeit und monatlicher Gebühr.',
      customerType: 'Kundenart',
      select: 'Bitte wählen',
      privat: 'Privat',
      gewerbe: 'Gewerbe',
      locations: 'Anzahl der Standorte',
      locations1: '1 Standort',
      locations2: '2–3 Standorte',
      locations3: '4 und mehr',
      cameraCount: 'Ungefähre Kameraanzahl',
      cameras1: '1–2 Kameras',
      cameras2: '3–6 Kameras',
      cameras3: '7–12 Kameras',
      cameras4: '13 und mehr',
      systemStatus: 'Anlagenstatus',
      statusNew: 'Neue Anlage',
      statusExisting: 'Bestehende Anlage',
      statusExtension: 'Erweiterung geplant',
      contractTerm: 'Gewünschte Vertragslaufzeit',
      termOpen: 'Offen / Nach Absprache',
      termMonthly: 'Monatlich kündbar',
      term12: '12 Monate',
      term24: '24 Monate',
      term36: '36 Monate',
      name: 'Name *',
      email: 'E-Mail *',
      phone: 'Telefon',
      company: 'Unternehmen',
      message: 'Zusätzliche Informationen',
      maxChars: 'Maximal 500 Zeichen',
      consent: 'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung dieser Anfrage zu. *',
      success: 'Vielen Dank für Ihre Anfrage. Wir melden uns zeitnah mit Ihrem individuellen Care-Angebot.',
      submit: 'Care-Anfrage senden',
      submitting: 'Wird gesendet...',
    },
  },
};